export const creditReviewLevelTypes = {
  sectorRiskLevel: 'sectorRiskLevel',
  businessClimate: 'businessClimate',
  countryRiskAssessment: 'countryRiskAssessment',
};
